import NotAuthroziedPage from "@components/NotAuthorized";
import ProtectedRoutes from "@components/ProtectedRoutes";
import EditorFileSelect from "@containers/Admin/EditorFileSelect/Loadable";
import { makeSelectAccess, makeSelectToken } from "@features/auth/authSlice";
import AdminLayout from "./layout/Admin";
import PublicLayout from "./layout/PublicLayout";
import { AdminRoutes } from "./routes/admin";
import { PublicRoutes } from "./routes/public";

import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { useSelector } from "react-redux";
import ErrorBoundary from "@components/ErrorBoundary";

const AppRoutes = () => {
  const token = useSelector(makeSelectToken);
  const access = useSelector(makeSelectAccess);

  if (token && access === null) {
    return <></>; // You can replace this with a spinner or some loading component
  }

  const router = createBrowserRouter([
    {
      path: "/editor-file-select",
      element: (
        <ProtectedRoutes>
          <EditorFileSelect />
        </ProtectedRoutes>
      ),
    },
    {
      path: "/",
      element: <PublicLayout />,
      children: PublicRoutes.map((each) => ({
        path: each.path,
        element: each.element,
      })),
    },
    {
      path: "/admin",
      element: (
        <ProtectedRoutes>
          <AdminLayout />
        </ProtectedRoutes>
      ),
      errorElement: <ErrorBoundary />,
      children: AdminRoutes.map((each) => {
        const hasRouteAccess = access[`/admin/${each.path}`] ? true : false;

        return {
          path: `/admin/${each.path}`,
          element: hasRouteAccess ? each.element : <NotAuthroziedPage />,
        };
      }),
    },
  ]);

  return <RouterProvider router={router} />;
};

export default AppRoutes;
